var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v("Filters")]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c("div", { staticClass: "title" }, [_vm._v("Account status")]),
              _c(
                "w-row",
                { style: { flexGrow: 1 } },
                [
                  _c(
                    "w-col",
                    { attrs: { sm: "6", xs: "12" } },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              disabled: _vm.disablePermantentFilter,
                              label: "Éénmalige aankoop",
                            },
                            model: {
                              value: _vm.v.accountStatus.hasPermanentAccount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.v.accountStatus,
                                  "hasPermanentAccount",
                                  $$v
                                )
                              },
                              expression: "v.accountStatus.hasPermanentAccount",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { style: { paddingLeft: "30px" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              disabled: _vm.disablePermantentExtraFilter,
                              label: "SP Actief",
                            },
                            model: {
                              value: _vm.v.accountStatus.activeService,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.v.accountStatus,
                                  "activeService",
                                  $$v
                                )
                              },
                              expression: "v.accountStatus.activeService",
                            },
                          }),
                          _c("w-checkbox", {
                            attrs: {
                              disabled: _vm.disablePermantentExtraFilter,
                              label: "SP Actief (permanent)",
                            },
                            model: {
                              value: _vm.v.accountStatus.permanentService,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.v.accountStatus,
                                  "permanentService",
                                  $$v
                                )
                              },
                              expression: "v.accountStatus.permanentService",
                            },
                          }),
                          _c("w-checkbox", {
                            attrs: {
                              disabled: _vm.disablePermantentExtraFilter,
                              label: "SP verlopen",
                            },
                            model: {
                              value: _vm.v.accountStatus.expiredService,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.v.accountStatus,
                                  "expiredService",
                                  $$v
                                )
                              },
                              expression: "v.accountStatus.expiredService",
                            },
                          }),
                          _c("w-checkbox", {
                            attrs: {
                              disabled:
                                _vm.disablePermantentExtraFilter ||
                                _vm.v.accountStatus.hasNeverBoughtSP,
                              label: "Heeft ooit SP gekocht",
                            },
                            model: {
                              value: _vm.v.accountStatus.hasBoughtSPAtLeastOnce,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.v.accountStatus,
                                  "hasBoughtSPAtLeastOnce",
                                  $$v
                                )
                              },
                              expression:
                                "v.accountStatus.hasBoughtSPAtLeastOnce",
                            },
                          }),
                          _c("w-checkbox", {
                            attrs: {
                              disabled:
                                _vm.disablePermantentExtraFilter ||
                                _vm.v.accountStatus.hasBoughtSPAtLeastOnce,
                              label: "Heeft nooit SP gekocht",
                            },
                            model: {
                              value: _vm.v.accountStatus.hasNeverBoughtSP,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.v.accountStatus,
                                  "hasNeverBoughtSP",
                                  $$v
                                )
                              },
                              expression: "v.accountStatus.hasNeverBoughtSP",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { sm: "6", xs: "12" } },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              disabled: _vm.disableSubscriptionFilter,
                              label: "Abonnement (kwartaal/jaarlijks)",
                            },
                            model: {
                              value: _vm.v.accountStatus.hasSubscription,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.v.accountStatus,
                                  "hasSubscription",
                                  $$v
                                )
                              },
                              expression: "v.accountStatus.hasSubscription",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { style: { paddingLeft: "30px" }, attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              disabled: _vm.disableSubscriptionExtraFilter,
                              label: "Is actief",
                            },
                            model: {
                              value: _vm.v.accountStatus.isNotExpired,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.v.accountStatus,
                                  "isNotExpired",
                                  $$v
                                )
                              },
                              expression: "v.accountStatus.isNotExpired",
                            },
                          }),
                          _c("w-checkbox", {
                            attrs: {
                              disabled: _vm.disableSubscriptionExtraFilter,
                              label: "Is verlopen",
                            },
                            model: {
                              value: _vm.v.accountStatus.isExpired,
                              callback: function ($$v) {
                                _vm.$set(_vm.v.accountStatus, "isExpired", $$v)
                              },
                              expression: "v.accountStatus.isExpired",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "title" }, [_vm._v("Editie")]),
              _c(
                "w-row",
                { style: { flexGrow: 1 } },
                [
                  _c(
                    "w-col",
                    { attrs: { sm: "6", xs: "12" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  disabled: _vm.disableTierFilter,
                                  value: _vm.hasTier(_vm.free),
                                  label: "Free",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateTier(_vm.free, $event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  disabled: _vm.disableTierFilter,
                                  value: _vm.hasTier(_vm.starter),
                                  label: "Starter",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateTier(_vm.starter, $event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  disabled: _vm.disableTierFilter,
                                  value: _vm.hasTier(_vm.pro),
                                  label: "Professional",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateTier(_vm.pro, $event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  disabled: _vm.disableTierFilter,
                                  value: _vm.hasTier(_vm.proplus),
                                  label: "Professional plus",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateTier(_vm.proplus, $event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  disabled: _vm.disableTierFilter,
                                  value: _vm.hasTier(_vm.enterprise),
                                  label: "Enterprise",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateTier(
                                      _vm.enterprise,
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { sm: "6", xs: "12" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  disabled: _vm.disableDemoFilter,
                                  label: "Demo",
                                },
                                model: {
                                  value: _vm.v.accountStatus.isDemo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.v.accountStatus, "isDemo", $$v)
                                  },
                                  expression: "v.accountStatus.isDemo",
                                },
                              }),
                              _c(
                                "w-col",
                                {
                                  style: { paddingLeft: "30px" },
                                  attrs: { xs: "12" },
                                },
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      disabled: _vm.disableDemoActiveFilter,
                                      label: "Is actief",
                                    },
                                    model: {
                                      value: _vm.v.accountStatus.activeDemo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.v.accountStatus,
                                          "activeDemo",
                                          $$v
                                        )
                                      },
                                      expression: "v.accountStatus.activeDemo",
                                    },
                                  }),
                                  _c("w-checkbox", {
                                    attrs: {
                                      disabled: _vm.disableDemoActiveFilter,
                                      label: "Is verlopen",
                                    },
                                    model: {
                                      value: _vm.v.accountStatus.expiredDemo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.v.accountStatus,
                                          "expiredDemo",
                                          $$v
                                        )
                                      },
                                      expression: "v.accountStatus.expiredDemo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "title" }, [_vm._v("Extra filters")]),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "6", xs: "12" } },
                [
                  _c("app-company-filters-modules", {
                    model: {
                      value: _vm.v.modules,
                      callback: function ($$v) {
                        _vm.$set(_vm.v, "modules", $$v)
                      },
                      expression: "v.modules",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { sm: "6", xs: "12" } },
                [
                  _c("app-select-discovered-us-from", {
                    attrs: {
                      "empty-text": "Niet van toepassing",
                      filters: _vm.v,
                      fancy: "",
                      label: "WinFakt ontdekt via",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { sm: "6", xs: "12" } },
                [
                  _c("app-company-emploteyee-select", {
                    attrs: { fancy: "", up: "" },
                    model: {
                      value: _vm.v.employeeAccounts,
                      callback: function ($$v) {
                        _vm.$set(_vm.v, "employeeAccounts", $$v)
                      },
                      expression: "v.employeeAccounts",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { sm: "6", xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      value: _vm.accountCreatedByValue,
                      items: _vm.accountCreatedByItems,
                      label: "Origineel van",
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setAccountCreatedByFilter($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", sm: "6" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      "max-date": _vm.v.createdBeforeDate,
                      label: "Account gemaakt vanaf",
                      nullable: "",
                      fancy: "",
                    },
                    model: {
                      value: _vm.v.createdAfterDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.v, "createdAfterDate", $$v)
                      },
                      expression: "v.createdAfterDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", sm: "6" } },
                [
                  _c("w-date-picker", {
                    attrs: {
                      "min-date": _vm.v.createdAfterDate,
                      label: "Account gemaakt tot",
                      nullable: "",
                      fancy: "",
                    },
                    model: {
                      value: _vm.v.createdBeforeDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.v, "createdBeforeDate", $$v)
                      },
                      expression: "v.createdBeforeDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", sm: "6" } },
                [
                  _c("app-select-company-did-not-purchase-reason", {
                    attrs: {
                      label: "Reden van geen aankoop",
                      fancy: "",
                      "include-misc": "",
                      "include-unkown": "",
                    },
                    model: {
                      value: _vm.v.didNotPurchaseReasons,
                      callback: function ($$v) {
                        _vm.$set(_vm.v, "didNotPurchaseReasons", $$v)
                      },
                      expression: "v.didNotPurchaseReasons",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", sm: "6" } },
                [
                  _c("w-select", {
                    attrs: { items: _vm.dbItems, fancy: "", label: "Database" },
                    model: {
                      value: _vm.v.dbId,
                      callback: function ($$v) {
                        _vm.$set(_vm.v, "dbId", $$v)
                      },
                      expression: "v.dbId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "title" }, [_vm._v("Variabelen")]),
          _c("app-company-filters-vars", {
            model: {
              value: _vm.v,
              callback: function ($$v) {
                _vm.v = $$v
              },
              expression: "v",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" Annuleren ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(" Bevestigen ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }